import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import { isFromAndroidWebview, isFromTDLPlatform, nextStepId } from '../../../configs/utils';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
export const loginGoogle = async (action, _datastore, { navigate, metaData, showPopup, instrumentTrack, network, setDatastore }) => {
    instrumentTrack('VERIFY_EMAIL_WITH_GOOGLE_CLICKED');
    const accountId = (await SharedPropsService.getUser())
        .linkedBorrowerAccounts[0].accountId;
    if (action?.payload?.value === '' || action?.payload?.value === undefined || action?.payload?.value === null)
        return;
    const response = await network.patch(`${api.accountAttributes}${accountId}`, {
        secureDataAttributeDetailsMap: {
            ['EMAIL']: {
                secureDataAttributeDetails: {
                    value: action?.payload?.value,
                    sources: ['SELF'],
                    verified: true,
                    verificationSources: ['GOOGLE_AUTH'],
                    collectedOn: `${Date.now()}`,
                    verifiedOn: `${Date.now()}`,
                },
                isPrimary: true,
            },
        },
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(ROUTE.EMAIL_VERIFY, 'emailVerifyScreen', {
            showErrorModal: false,
            errorDescription: '',
        });
    }
    else if (response?.response?.status === 400) {
        await setDatastore(ROUTE.EMAIL_VERIFY, 'emailVerifyScreen', {
            showErrorModal: true,
            errorDescription: response?.response?.data.message,
        });
    }
    else {
        await setDatastore(ROUTE.EMAIL_VERIFY, 'emailVerifyScreen', {
            showErrorModal: true,
            errorDescription: 'Something went wrong, please try again.',
        });
    }
    const user = response.data;
    if (user) {
        await SharedPropsService.setUser(user);
        const route = await nextStepId(user?.linkedApplications[0]?.currentStepId);
        await navigate(route?.routeId, route?.params);
    }
};
export const otherEmail = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('VERIFY_EMAIL_WITH_OTHER_CLICKED');
    navigate(ROUTE.ENTER_EMAIL, { applicationId: action.payload.applicationId });
};
export const goHome = async (action, _datastore, { navigate }) => {
    if (await SharedPropsService.showHome()) {
        await navigate(ROUTE.BORROWER_LANDING_SCREEN);
    }
    else {
        window?.parent?.postMessage("Exit callback", "*");
        if (isFromAndroidWebview() && isFromTDLPlatform()) {
            window.open("closeActivity", "_parent");
        }
        //@ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.CONTACT_US_CARD);
};
export const closeModal = async (action, _datastore, { navigate, setDatastore }) => {
    await setDatastore(ROUTE.EMAIL_VERIFY, 'emailVerifyScreen', {
        showErrorModal: false,
        errorDescription: '',
    });
};
